module.exports = __webpack_public_path__ + "static/media/Assessment Form.0cf43da7.png";